import { AnimatePresence, motion } from 'framer-motion';
import styled from 'styled-components';
import { IconCheckMark, IconXMark } from '../../../styles/Icons';

const CheckboxStyled = styled.div<{
  size?: string;
  x?: boolean;
  margin?: string;
  pointer?: boolean;
  checked?: boolean;
  checkColor?: string;
}>`
  width: ${({ size }) => size ?? '26'}px;
  height: ${({ size }) => size ?? '26'}px;
  border-radius: 50%;
  background-color: ${({ theme, x }) =>
    x ? theme.colors.neutral500 : theme.colors.neutral900};
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid
    ${({ theme, x }) => (x ? theme.colors.neutral500 : theme.colors.neutral900)};
  flex: none;

  transition: all 0.2s ease-in-out;

  ${({ margin }) => margin && `margin:${margin}`};
  ${({ pointer }) => pointer && `cursor: pointer`};

  ${({ checkColor }) =>
    checkColor &&
    `
  
  background: ${checkColor};
  border-color: ${checkColor};
  
  `};

  ${({ checked }) =>
    !checked &&
    `
    background-color: rgba(0,0,0,0);
`}
`;

interface CheckboxProps {
  onClick?: any;
  onChange?: (checked: boolean) => void;
  checked: boolean;
  size?: string;
  margin?: string;
  x?: boolean;
  pointer?: boolean;
  checkColor?: string;
}

export const Checkbox = ({
  onClick,
  onChange,
  checked,
  size,
  margin,
  x,
  pointer,
  checkColor
}: CheckboxProps) => {
  return (
    <CheckboxStyled
      x={x}
      role='checkbox'
      aria-checked={checked}
      tabIndex={onChange || onClick ? 0 : undefined}
      onClick={(event) => {
        if (onChange) {
          event.stopPropagation();
          onChange(!checked);
        }
        onClick?.(event);
      }}
      onKeyDown={(event) => {
        if (event.key === ' ' && (onChange || onClick)) {
          event.preventDefault();
          event.currentTarget.click();
        }
      }}
      margin={margin}
      size={size}
      checked={checked}
      pointer={pointer}
      checkColor={checkColor}>
      <AnimatePresence exitBeforeEnter>
        {!x && checked ? (
          <motion.div
            key={1}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{
              duration: 0.2
            }}>
            <IconCheckMark size={`${size ? Number(size) / 2 : 24 / 2}`} />
          </motion.div>
        ) : (
          <></>
        )}
      </AnimatePresence>
      {x && <IconXMark />}
    </CheckboxStyled>
  );
};
